import type { WsConfig } from '../types';

export const wsConfig: WsConfig = {
  name: 'Workstation de Resultados',

  layers: [
    {
      id: 'layer-fundacao',
      name: 'Fundação',
      slug: 'fundacao',
      color: 'ws-fundacao',
      position: 0,
      icon: 'foundation',
    },
    {
      id: 'layer-infraestrutura',
      name: 'Infraestrutura',
      slug: 'infraestrutura',
      color: 'ws-infraestrutura',
      position: 1,
      icon: 'build',
    },
    {
      id: 'layer-sistemas',
      name: 'Sistemas',
      slug: 'sistemas',
      color: 'ws-sistemas',
      position: 2,
      icon: 'settings',
    },
    {
      id: 'layer-conteudo',
      name: 'Conteúdo',
      slug: 'conteudo',
      color: 'ws-conteudo',
      position: 3,
      icon: 'edit_note',
    },
    {
      id: 'layer-canais',
      name: 'Canais',
      slug: 'canais',
      color: 'ws-canais',
      position: 4,
      icon: 'share',
    },
    {
      id: 'layer-ads-growth',
      name: 'Ads & Growth',
      slug: 'ads-growth',
      color: 'ws-ads-growth',
      position: 5,
      icon: 'trending_up',
    },
  ],

  kanbanColumns: [
    { id: 'todo', title: 'A Fazer' },
    { id: 'doing', title: 'Executando' },
    { id: 'support', title: 'Suporte' },
    { id: 'done', title: 'Concluído' },
  ],

  features: {
    gamification: true,
    aiChat: true,
    spacedRepetition: true,
    nps: true,
  },

  csScoreLabels: [
    'Fiz mas não entendi',
    'Entendi parcialmente',
    'Consigo fazer com ajuda',
    'Consigo fazer sozinho',
    'Consigo fazer e explicar',
  ],

  procrastinationThresholds: {
    warning: 24,
    attention: 48,
    risk: 72,
  },
};

export default wsConfig;
